import { createIcon } from './create-icon'

export const Pin1 = createIcon({
  displayName: 'Pin1',
  paths: [
    'M760.819 616.32l-80.213-120.363-37.589-225.323 69.803-69.803c12.245-12.203 15.872-30.549 9.259-46.507-6.613-15.915-22.144-26.325-39.424-26.325h-341.333c-17.237 0-32.811 10.411-39.381 26.325-6.613 15.957-2.987 34.304 9.216 46.507l69.845 69.803-37.589 225.323-80.256 120.363c-8.704 13.099-9.515 29.909-2.091 43.819 7.424 13.867 21.888 22.528 37.589 22.528h128l85.333 256 85.333-256h128c15.744 0 30.208-8.661 37.632-22.528 7.424-13.909 6.613-30.72-2.133-43.819z'
  ]
})
